// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Orphan-FB-comments admin page (superadmin only) */

.orphan-comments-page {
  padding: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
}

.orphan-header h2 {
  margin: 0 0 0.25rem;
  color: #1e293b;
}

.orphan-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.92rem;
}

/* ── Stats summary ── */
.orphan-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 0.75rem;
  margin: 1.25rem 0;
}

.orphan-stat-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.85rem 1rem;
}

.orphan-stat-label {
  font-size: 0.78rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.orphan-stat-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #1e293b;
  margin-top: 0.25rem;
}

.orphan-stat-note {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 0.15rem;
  font-style: italic;
}

/* ── Toolbar ── */
.orphan-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.orphan-filters {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.orphan-filters label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.88rem;
  color: #475569;
}

.orphan-filters select {
  padding: 0.35rem 0.6rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  font-size: 0.88rem;
}

.orphan-bulk-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.orphan-selection-count {
  font-size: 0.85rem;
  color: #64748b;
}

/* ── Buttons ── */
.orphan-btn {
  padding: 0.4rem 0.85rem;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 0.85rem;
  transition: background 0.15s, border-color 0.15s;
}

.orphan-btn:hover:not(:disabled) {
  background: #f1f5f9;
}

.orphan-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.orphan-btn-secondary {
  background: #f8fafc;
}

.orphan-btn-danger {
  background: #fee2e2;
  border-color: #fca5a5;
  color: #991b1b;
}

.orphan-btn-danger:hover:not(:disabled) {
  background: #fecaca;
}

.orphan-btn-sm {
  padding: 0.25rem 0.55rem;
  font-size: 0.78rem;
}

/* ── Table ── */
.orphan-table {
  width: 100%;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.85rem;
  overflow: hidden;
}

.orphan-table th,
.orphan-table td {
  padding: 0.6rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: top;
}

.orphan-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #475569;
  position: sticky;
  top: 0;
}

.orphan-table tbody tr:last-child td {
  border-bottom: none;
}

.orphan-table tbody tr:hover {
  background: #f8fafc;
}

.orphan-id {
  color: #94a3b8;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.78rem;
}

.orphan-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.78rem;
  color: #475569;
}

.orphan-content {
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.orphan-external-id {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Reason badges ── */
.orphan-badge {
  display: inline-block;
  padding: 0.18rem 0.55rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 600;
  border: 1px solid transparent;
}

.orphan-badge-failed {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.orphan-badge-missing {
  background: #fef3c7;
  color: #92400e;
  border-color: #fcd34d;
}

.orphan-badge-disconnected {
  background: #e0e7ff;
  color: #3730a3;
  border-color: #a5b4fc;
}

/* ── Pagination ── */
.orphan-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
  font-size: 0.85rem;
  color: #475569;
}

.orphan-pagination > div {
  display: flex;
  gap: 0.4rem;
}

/* ── Empty / loading / error states ── */
.orphan-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #64748b;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 10px;
}

.orphan-empty-icon {
  font-size: 2.5rem;
  display: block;
  margin-bottom: 0.5rem;
}

.orphan-loading {
  text-align: center;
  padding: 2rem;
  color: #64748b;
}

.orphan-error {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fca5a5;
  padding: 0.7rem 1rem;
  border-radius: 8px;
  margin: 1rem 0;
}
`, "",{"version":3,"sources":["webpack://./src/admin/pages/OrphanComments.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6EAA6E;EAC7E,kBAAkB;AACpB;;AAEA;EACE,6EAA6E;EAC7E,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* Orphan-FB-comments admin page (superadmin only) */\n\n.orphan-comments-page {\n  padding: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.orphan-header h2 {\n  margin: 0 0 0.25rem;\n  color: #1e293b;\n}\n\n.orphan-subtitle {\n  margin: 0;\n  color: #64748b;\n  font-size: 0.92rem;\n}\n\n/* ── Stats summary ── */\n.orphan-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 0.75rem;\n  margin: 1.25rem 0;\n}\n\n.orphan-stat-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.85rem 1rem;\n}\n\n.orphan-stat-label {\n  font-size: 0.78rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.orphan-stat-value {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-top: 0.25rem;\n}\n\n.orphan-stat-note {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  margin-top: 0.15rem;\n  font-style: italic;\n}\n\n/* ── Toolbar ── */\n.orphan-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin: 1rem 0;\n  padding: 0.75rem 1rem;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n}\n\n.orphan-filters {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.orphan-filters label {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.88rem;\n  color: #475569;\n}\n\n.orphan-filters select {\n  padding: 0.35rem 0.6rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 0.88rem;\n}\n\n.orphan-bulk-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.orphan-selection-count {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n/* ── Buttons ── */\n.orphan-btn {\n  padding: 0.4rem 0.85rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #fff;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.orphan-btn:hover:not(:disabled) {\n  background: #f1f5f9;\n}\n\n.orphan-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.orphan-btn-secondary {\n  background: #f8fafc;\n}\n\n.orphan-btn-danger {\n  background: #fee2e2;\n  border-color: #fca5a5;\n  color: #991b1b;\n}\n\n.orphan-btn-danger:hover:not(:disabled) {\n  background: #fecaca;\n}\n\n.orphan-btn-sm {\n  padding: 0.25rem 0.55rem;\n  font-size: 0.78rem;\n}\n\n/* ── Table ── */\n.orphan-table {\n  width: 100%;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.85rem;\n  overflow: hidden;\n}\n\n.orphan-table th,\n.orphan-table td {\n  padding: 0.6rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid #e2e8f0;\n  vertical-align: top;\n}\n\n.orphan-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #475569;\n  position: sticky;\n  top: 0;\n}\n\n.orphan-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.orphan-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n.orphan-id {\n  color: #94a3b8;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.78rem;\n}\n\n.orphan-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.78rem;\n  color: #475569;\n}\n\n.orphan-content {\n  max-width: 360px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.orphan-external-id {\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Reason badges ── */\n.orphan-badge {\n  display: inline-block;\n  padding: 0.18rem 0.55rem;\n  border-radius: 999px;\n  font-size: 0.74rem;\n  font-weight: 600;\n  border: 1px solid transparent;\n}\n\n.orphan-badge-failed {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.orphan-badge-missing {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fcd34d;\n}\n\n.orphan-badge-disconnected {\n  background: #e0e7ff;\n  color: #3730a3;\n  border-color: #a5b4fc;\n}\n\n/* ── Pagination ── */\n.orphan-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1rem;\n  font-size: 0.85rem;\n  color: #475569;\n}\n\n.orphan-pagination > div {\n  display: flex;\n  gap: 0.4rem;\n}\n\n/* ── Empty / loading / error states ── */\n.orphan-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #64748b;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 10px;\n}\n\n.orphan-empty-icon {\n  font-size: 2.5rem;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n.orphan-loading {\n  text-align: center;\n  padding: 2rem;\n  color: #64748b;\n}\n\n.orphan-error {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fca5a5;\n  padding: 0.7rem 1rem;\n  border-radius: 8px;\n  margin: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
